import { useState, useEffect } from 'react';
import axios from '../../../../axios-order';
import { useLocation, useHistory } from 'react-router-dom';

import BoxWrapper from "../../../../components/ui/boxWrapper";


const TdsLiabilityCalcutionData = () => {
    const history = useHistory()
    const location = useLocation();
    const { items } = location.state || {};
    const [tdsLiabilityCalcutionData, setTdsLiabilityCalcutionData] = useState([])
    const [liabilatyCalTableSearchValue, setLiabilatyCalTableSearch] = useState("");
    const [tdsLiabilityCalculationForSearch, setTdsLiabilityCalculationForSearch] = useState();

    useEffect(() => {
        getTdsLiabiltyCalcultionData()
    }, []);

    const getTdsLiabiltyCalcultionData = () => {
        const payLoadData = {
            business_entity_id: localStorage.getItem('business_entity_id'),
            financial_year: localStorage.getItem('financial_year_26Q'),
            month_name: items.month_name
        };
        axios.post('/get_payable_details_records', payLoadData)
            .then((res) => {
                if (res?.data?.status) {
                    const data = res?.data?.records || []
                    setTdsLiabilityCalcutionData(data)
                    setTdsLiabilityCalculationForSearch(data)
                }
            }).catch((err) => {

            })
    }

    const indianFormatDate = (date) => {
        let dateArr = date.split("-");
        return dateArr[2] + "-" + dateArr[1] + "-" + dateArr[0];
    };

    const indianRupeesFormat = (value) =>
        value
            ? new Intl.NumberFormat("en-IN", {
                style: "currency",
                currency: "INR",
                maximumSignificantDigits: 10,
            }).format(Number(value)?.toFixed(2))
            : 0;


    const tdsLiabilityCalculationTableBody = () => {
        if (tdsLiabilityCalcutionData && tdsLiabilityCalcutionData.length !== 0) {
            return tdsLiabilityCalcutionData.map((item, i) => {
                // console.log(item.tds_payable_per_books);
                return (
                    <tr key={i}>
                        <td>{item.name}</td>

                        <td>{item.pan}</td>

                        <td>{item["resident/non_resident"]}</td>

                        <td>{item.threshold_applicability}</td>

                        <td>{item.bill_no}</td>

                        <td>{item.bill_date && indianFormatDate(item.bill_date)}</td>

                        <td>{item.booking_date && indianFormatDate(item.booking_date)}</td>

                        <td>
                            {item["taxable+nontaxable"]
                                ? indianRupeesFormat(item["taxable+nontaxable"].toFixed(2))
                                : indianRupeesFormat(item["taxable+nontaxable"])}
                        </td>

                        <td>{item.tds_section}</td>

                        <td>{item["206AB_applicable"]}</td>

                        <td>
                            {item.tds_payable_per_books
                                ? indianRupeesFormat(item.tds_payable_per_books.toFixed(2))
                                : indianRupeesFormat(item.tds_payable_per_books)}
                        </td>

                        <td>
                            {item.ltds_amount
                                ? indianRupeesFormat(item.ltds_amount.toFixed(2))
                                : indianRupeesFormat(item.ltds_amount)}
                        </td>

                        {/* <td>{indianRupeesFormat(item.ltds_amount_as_per_certificate)}</td> */}

                        <td>
                            {item.gross_amount_as_per_provision
                                ? indianRupeesFormat(
                                    item.gross_amount_as_per_provision.toFixed(2)
                                )
                                : indianRupeesFormat(item.gross_amount_as_per_provision)}
                        </td>

                        <td>
                            {item.net_gross_amount
                                ? indianRupeesFormat(item.net_gross_amount.toFixed(2))
                                : indianRupeesFormat(item.net_gross_amount)}
                        </td>

                        <td>
                            {item.tds_on_provision
                                ? indianRupeesFormat(item.tds_on_provision.toFixed(2))
                                : indianRupeesFormat(item.tds_on_provision)}
                        </td>

                        <td>
                            {item.net_tds
                                ? indianRupeesFormat(item.net_tds.toFixed(2))
                                : indianRupeesFormat(item.net_tds)}
                        </td>
                        <td>{item.ltds_amount && indianRupeesFormat(item.ltds_amount)}</td>

                        <td>{item.ltds_percent}</td>

                        <td>{item["company/non_company"]}</td>
                        <td>{item.tds_percent_per_cws_tool}</td>

                        <td>
                            {item.tds_payable_amount_per_cws
                                ? indianRupeesFormat(item.tds_payable_amount_per_cws.toFixed(2))
                                : indianRupeesFormat(item.tds_payable_amount_per_cws)}
                        </td>

                        <td>
                            {item.difference_in_value
                                ? indianRupeesFormat(item.difference_in_value.toFixed(2))
                                : indianRupeesFormat(item.difference_in_value)}
                        </td>

                        <td>{item.criteria}</td>
                        <td>{item.remarks}</td>
                    </tr>
                );
            });
        } else {
            return (
                <tr>
                    <td style={{ textAlign: "center", color: "red" }} colSpan={23}>
                        No Data Found!
                    </td>
                </tr>
            );
        }
    };

    const searchInputHandlerForLiabilityTable = async (e) => {
        let value = e.target.value;
        let filteredValue = tdsLiabilityCalculationForSearch.filter((row) => {
            return (
                row.name.toLowerCase().includes(value.toLowerCase()) ||
                row.pan.toLowerCase().includes(value.toLowerCase()) ||
                (row.bill_date && row.bill_date.includes(value))
            );
        });
        setLiabilatyCalTableSearch(value);
        setTdsLiabilityCalcutionData(filteredValue);
    };


    return (
        <BoxWrapper
            boxTitle=" TDS liability Calculation"
            
            enableAddButton={true}
            addButtonLabel={'Back'}
            addButtonHandlerFn={() => history.goBack()}
            enableSearchInput={true}
            searchInputPlaceholder="Search..."
            searchInputOnchange={searchInputHandlerForLiabilityTable}
        >
            <div className="responsive-table">
                <table className="custome-two-row-header-table">
                    <tbody>
                        <tr>
                            <th
                                style={{ background: "yellow", width: "300px" }}
                                colSpan={12}
                            >
                                As Per Books
                            </th>
                            <th
                                style={{ background: "#f0ba42", width: "100px" }}
                                colSpan={4}
                            >
                                Provisions/Reversal Tracker
                            </th>
                            <th
                                style={{ background: "#007bff", width: "100px" }}
                                colSpan={7}
                            >
                                CWS
                            </th>
                            <th
                                style={{ background: "#ebc668", width: "50px" }}
                                rowSpan={2}
                            >
                                Remarks
                            </th>
                        </tr>
                        <tr>
                            <th>Name</th>
                            <th>PAN</th>
                            <th>Resident/Non Resident</th>
                            <th>Threshold Applicability</th>
                            <th>Bill No</th>
                            <th>Bill Date</th>
                            <th>Booking/recording date</th>
                            <th>Taxable + Non Taxable Amount (excluding GST/CESS)</th>
                            <th>TDS Section</th>
                            <th>206AB applicable - Y/N</th>
                            <th>TDS Payable per books</th>
                            <th>Net LTDS</th>
                            {/* <th>LTDS Amount As Per Certificate</th> */}

                            <th>Gross amount as per provision</th>
                            <th>Net Gross Amount</th>
                            <th>TDS On Provision</th>
                            <th>Net TDS</th>

                            <th>LTDS Amount</th>
                            <th>LTDS%</th>

                            <th>Company/Non Company</th>
                            <th>TDS % per CWS tool</th>
                            <th>TDS Payable Amount as per CWS</th>
                            <th>Difference in Value</th>
                            <th>Criteria</th>
                        </tr>
                        {tdsLiabilityCalculationTableBody()}
                    </tbody>
                </table>
            </div>
        </BoxWrapper>
    );
};

export default TdsLiabilityCalcutionData;